import React from 'react';
import { DialogContent } from '@mui/material';
import BootstrapDialog, {
  BootstrapDialogTitle,
} from '../../common/dialog/BootstrapDialog';
import OrderBookSummary from './OrderBookSummary';
import OrderProductListContainer from '../../../containers/projectmng/obtainorder/OrderProductListContainer';

import OrderBookApprovalContainer from '../../../containers/projectmng/obtainorder/OrderBookApprovalContainer';
import OrderBookApprovalFormV2 from '../../approval/OrderBookApprovalFormV2';
import ApprovalFormContainer from '../../../containers/projectmng/approval/ApprovalFormContainer';
import DetailTemplate from '../../common/template/DetailTemplate';

import SalesProfitInfoContainer from '../../../containers/projectmng/obtainorder/SalesProfitInfoContainer';
import OrderBookInfo from './OrderBookInfo';
import OrderBookFileListContainer from '../../../containers/projectmng/obtainorder/OrderBookFileListContainer';

const OrderBookModal = ({
  project,
  lineId,
  setLineId,
  finalApprovalYn,
  setFinalApprovalYn,
  finalApprovalComment,
  setFinalApprovalComment,
  approvalAmount,
  approvalList,
  user,
  type,
  open,
  handleClose,
  orderInfo,
  scollToRef,
}) => {
  return (
    <BootstrapDialog
      open={open}
      onClose={handleClose}
      fullScreen
      fullWidth={true}
    >
      <BootstrapDialogTitle onClose={handleClose}>
        수주품의서
        {type === 'edit' && orderInfo && orderInfo?.ordYn === 'S' && (
          <ApprovalFormContainer
            docuCd={orderInfo?.roUuid}
            user={user}
            type="order"
          />
        )}
      </BootstrapDialogTitle>

      <DialogContent
        dividers
        sx={{
          height: '90vh',
          overflowY: 'auto',
        }}
      >
        {type === 'edit' && (
          <DetailTemplate title="개요">
            <OrderBookSummary
              orderInfo={orderInfo}
              approvalList={approvalList}
            />
          </DetailTemplate>
        )}
        <div ref={scollToRef}></div>
        <DetailTemplate title="기본사항">
          <OrderBookInfo project={project} orderInfo={orderInfo} />
        </DetailTemplate>

        {type === 'edit' && (
          <DetailTemplate title="수주품의서 파일 리스트">
            <OrderBookFileListContainer orderInfo={orderInfo} />
          </DetailTemplate>
        )}

        <DetailTemplate title="최종 매출 이익 (내부거래 포함)">
          <SalesProfitInfoContainer orderInfo={orderInfo} project={project} />
        </DetailTemplate>

        {(type === 'add' ||
          (type === 'edit' &&
            orderInfo?.crtUsr === user?.usrUuid &&
            (!approvalList || approvalList.length === 0))) && (
          <DetailTemplate title="결재선 확인">
            <OrderBookApprovalFormV2
              lineId={lineId}
              setLineId={setLineId}
              finalApprovalYn={finalApprovalYn}
              setFinalApprovalYn={setFinalApprovalYn}
              finalApprovalComment={finalApprovalComment}
              setFinalApprovalComment={setFinalApprovalComment}
              amount={approvalAmount}
            />
          </DetailTemplate>
        )}

        {type === 'edit' && (
          <DetailTemplate title="결재 내역">
            <OrderBookApprovalContainer approvalList={approvalList} />
          </DetailTemplate>
        )}
        <DetailTemplate title="원가산출 내역">
          <OrderProductListContainer />
        </DetailTemplate>
      </DialogContent>
    </BootstrapDialog>
  );
};

export default OrderBookModal;
